import { ApiError } from "../../apiError";

export const RoutePostAuthSsoSwitchMerchant = "/auth/sso/switch-merchant";

export interface PayloadPostAuthSsoSwitchMerchant {
  merchantId: number;
}

export type ResponsePostAuthSsoSwitchMerchant =
  | {
      merchantId: number;
      token: string;
    }
  | ApiError;
